// extracted by mini-css-extract-plugin
export default {"body":"ManualJournal_body__1BJew"};